<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout search-area">
      <md-card>
        <md-card-header md-alignment="space-between">
          <h4 class="title"><md-icon>search</md-icon>검색 조건</h4>
        </md-card-header>
        <md-card-content>
          <table class="flex-table">
            <colgroup>
              <col width="10%" />
              <col width="10%" />
              <col width="1%" />
              <col width="10%" />
              <col width="*" />
            </colgroup>
            <tr>
              <th>대상학기</th>
              <td style="border-right: none;">
                <select v-model="semesterCdFrom" name="semesterCd">
                  <option value="">선택</option>
                  <option
                    v-for="item in semesterCdList"
                    :key="item.code"
                    :label="item.codeNm"
                    :value="item.code"
                  >
                    {{ item }}
                  </option>
                </select>
              </td>
              <td
                style="border-left: none; border-right: none; text-align: center"
              >
                ~
              </td>
              <td style="border-left: none;">
                <select v-model="semesterCdTo" name="semesterCd">
                  <option value="">선택</option>
                  <option
                    v-for="item in semesterCdList"
                    :key="item.code"
                    :label="item.codeNm"
                    :value="item.code"
                  >
                    {{ item }}
                  </option>
                </select>
              </td>
              <md-button
                class="md-info md-sm"
                @click="getDashbordInfo"
                style="margin-left: 5px;"
              >
                <md-icon>check</md-icon>검색
              </md-button>
              <!--              <td colspan="3" style="visibility: hidden; border:none;"/>-->
            </tr>
          </table>
        </md-card-content>
      </md-card>
      <md-card>
          <md-card-header
            style="display: flex; justify-content: space-between; align-items: center;"
          >
            <h4 class="title" style="margin: 0; display: flex; align-items: center;">
              <md-icon>list</md-icon>
              검색 결과
            </h4>
            <md-button class="md-info md-sm" @click="downloadDashboardExcel" style="float: right; margin-bottom: 10px;">
              <md-icon>file_download</md-icon>엑셀 다운로드
            </md-button>
          </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-33 no-padding">
              <md-card>
                <md-card-header md-alignment="space-between">
                  <h4 class="title">
                    <md-icon>receipt_long</md-icon>
                    개인명의
                  </h4>
                </md-card-header>
                <md-card-content>
                  <md-table>
                    <md-table-row>
                      <md-table-head>지급교우</md-table-head>
                      <md-table-head>지급인원</md-table-head>
                      <md-table-head>지급금액</md-table-head>
                    </md-table-row>
                    <md-table-row align="right">
                      <md-table-cell>
                        {{ this.getCurrency(schaInfoList[0].gb1Mem) }} 명
                      </md-table-cell>
                      <md-table-cell>
                        {{ this.getCurrency(schaInfoList[0].gb1Apply) }} 명
                      </md-table-cell>
                      <md-table-cell>
                        {{ this.getCurrency(schaInfoList[0].gb1Amount) }} 원
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>
              </md-card>
            </div>
            <div class="md-layout-item md-size-34 no-padding">
              <md-card>
                <md-card-header md-alignment="space-between">
                  <h4 class="title">
                    <md-icon>receipt_long</md-icon>
                    교우자녀
                  </h4>
                </md-card-header>
                <md-card-content>
                  <md-table>
                    <md-table-row>
                      <md-table-head>지급인원</md-table-head>
                      <md-table-head>지급금액</md-table-head>
                    </md-table-row>
                    <md-table-row align="right">
                      <md-table-cell>
                        {{ this.getCurrency(schaInfoList[0].gb2Apply) }} 명
                      </md-table-cell>
                      <md-table-cell>
                        {{ this.getCurrency(schaInfoList[0].gb2Amount) }} 원
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>
              </md-card>
            </div>
            <div class="md-layout-item md-size-33 no-padding">
              <md-card>
                <md-card-header md-alignment="space-between">
                  <h4 class="title">
                    <md-icon>receipt_long</md-icon>
                    교우회(장학)
                  </h4>
                </md-card-header>
                <md-card-content>
                  <md-table>
                    <md-table-row>
                      <md-table-head>지급인원</md-table-head>
                      <md-table-head>지급금액</md-table-head>
                    </md-table-row>
                    <md-table-row align="right">
                      <md-table-cell>
                        {{ this.getCurrency(schaInfoList[0].gb3Apply) }} 명
                      </md-table-cell>
                      <md-table-cell>
                        {{ this.getCurrency(schaInfoList[0].gb3Amount) }} 원
                      </md-table-cell>
                    </md-table-row>
                  </md-table>
                </md-card-content>
              </md-card>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaApi from "@/kuaa/kuaa-api";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default {
  name: "ScholarshipDashboard",

  components: {},

  created() {
    this.getSemesterCdList();
  },

  data() {
    return {
      semesterCdList: [],
      schaInfoList: null,
      semesterCdFrom: null,
      semesterCdTo: null
    };
  },

  methods: {
    
    downloadDashboardExcel() {
      if (!this.schaInfoList || this.schaInfoList.length === 0) {
        kuaaFnc.showSwal("엑셀 다운로드", "다운로드할 데이터가 없습니다.");
        return;
      }
      // 엑셀 데이터 구성
      const excelData = [
        {
          구분: "개인명의",
          지급교우: this.getCurrency(this.schaInfoList[0].gb1Mem) + " 명",
          지급인원: this.getCurrency(this.schaInfoList[0].gb1Apply) + " 명",
          지급금액: this.getCurrency(this.schaInfoList[0].gb1Amount) + " 원"
        },
        {
          구분: "교우자녀",
          지급교우: "",
          지급인원: this.getCurrency(this.schaInfoList[0].gb2Apply) + " 명",
          지급금액: this.getCurrency(this.schaInfoList[0].gb2Amount) + " 원"
        },
        {
          구분: "교우회(장학)",
          지급교우: "",
          지급인원: this.getCurrency(this.schaInfoList[0].gb3Apply) + " 명",
          지급금액: this.getCurrency(this.schaInfoList[0].gb3Amount) + " 원"
        }
      ];

      const ws = XLSX.utils.json_to_sheet(excelData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Dashboard");

      const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      saveAs(new Blob([wbout], { type: "application/octet-stream" }), "장학대시보드.xlsx");
    },
    
    getSemesterCdList() {
      kuaaFnc.fncSemesterCodes(null, res => {
        this.semesterCdList = res.data.data.contents;
        this.semesterCdFrom = this.semesterCdList[0]?.code;
        this.semesterCdTo = this.semesterCdList[0]?.code;
        this.getDashbordInfo();
      });
    },

    getDashbordInfo() {
      let modalOptions = null;
      if (this.semesterCdFrom > this.semesterCdTo) {
        modalOptions = kuaaFnc.getSwalModaloptions({
          html: "대상학기를 정확히 선택해 주세요."
        });
        Swal.fire(modalOptions);
        return false;
      }

      kuaaApi.sendServer(
        URL_CONST.GET_DASHBOARD_SCHA_INFO,
        {
          semesterCdFrom: this.semesterCdFrom,
          semesterCdTo: this.semesterCdTo
        },
        "post",
        response => {
          console.log(response);
          if (response.data.result) {
            console.table(response.data);
            this.schaInfoList = response.data.data.schaInfo;
          } else {
            kuaaFnc.showSwal(
              "Dashboard data error",
              response.data.resultMessage
            );
          }
        }
      );
    },

    /**
     * 숫자 세 자리마다 콤마 추가
     * @param num
     * @returns {string}
     */
    getCurrency(num) {
      return num
        ? num.toString().replace(/(\d)(?=(?:\d{3})+(?!\d))/g, "$1,")
        : 0;
    }
  }
};
</script>

<style scoped></style>
